import request from '@/utils/request'
import { getCommunityId } from '@/api/community/communityApi'

// 获取门禁进出记录列表
export function listAccessControlInouts(params) {
  return request({
    url: '/machineRecord.listMachineRecords',
    method: 'get',
    params: {
      ...params,
      communityId: getCommunityId(),
      recordTypeCd: '8888'
    }
  }).then(response => {
    const result = response.data || {}
    return {
      data: result.machineRecords || [],
      total: result.total || 0
    }
  })
}

// 获取门禁设备列表
export function listAccessControls(params) {
  return request({
    url: '/isupDevice.listPropertyDevices',
    method: 'get',
    params: {
      ...params,
      communityId: getCommunityId(),
      bindState: '1100'
    }
  }).then(response => {
    const result = response.data || {}
    if (result.code !== 0) {
      throw new Error(result.msg || '获取门禁设备失败')
    }
    return { data: result.data || [] }
  })
}
